import httpStore from "@/api/httpStore.js";

// Precios de catálogo (part_price_catalog) para productos con dependencia B2/Z.
// La respuesta llega snake_case -> camelCase automáticamente (ver CLAUDE.md).
// Las escrituras van en snake_case, que es lo que espera el modelo PHP.

// priceLogic: "fixed" | "calculated" | "none" (sin precio de catálogo todavía)
export function loadCatalogPrices({
  search = "",
  page = 1,
  limit = 50,
  dependencia = null,
  priceLogic = null
} = {}) {
  const params = { search, page, limit };
  if (dependencia) {
    params.dependencia = dependencia;
  }
  if (priceLogic) {
    params.price_logic = priceLogic;
  }
  return httpStore.get("/part_price_catalog", { params }).then(res => res.data);
}

// entry: { nkrCode, cost, priceGroup, priceLogic, online, repairShop,
//          wholesale, precio4..6, onlineMinPrice, repairShopMinPrice, wholesaleMinPrice, precio4..6MinPrice }
// list_price y dealer_profit NO se envían: para LP45 el backend deriva list_price de
// cost x settings.lp45_dealer_profit; para el resto usa part_info_local.list_price
// (poblado por Infoauto).
export function saveCatalogPrice(entry) {
  const payload = {
    nkr_code: entry.nkrCode,
    cost: entry.cost,
    price_group: entry.priceGroup,
    price_logic: entry.priceLogic,
    online: entry.online,
    repair_shop: entry.repairShop,
    wholesale: entry.wholesale,
    precio4: entry.precio4,
    precio5: entry.precio5,
    precio6: entry.precio6,
    online_min_price: entry.onlineMinPrice,
    repair_shop_min_price: entry.repairShopMinPrice,
    wholesale_min_price: entry.wholesaleMinPrice,
    precio4_min_price: entry.precio4MinPrice,
    precio5_min_price: entry.precio5MinPrice,
    precio6_min_price: entry.precio6MinPrice
  };
  return httpStore.post("/part_price_catalog", payload).then(res => res.data);
}

export function deleteCatalogPrice(nkrCode) {
  return httpStore
    .delete(`/part_price_catalog?nkr_code=${encodeURIComponent(nkrCode)}`)
    .then(res => res.data);
}

// Dry-run: recalcula (sin persistir) online/repairShop/wholesale para todas las
// filas price_logic = 'calculated' contra el cost/price_group/list_price actuales.
// Útil tras cambiar price_groups o el dealer_profit global (lp45_dealer_profit).
export function previewRecalculateCatalogPrices() {
  return httpStore
    .get("/part_price_catalog/recalculate_preview")
    .then(res => res.data);
}

// Aplica el recálculo. Sin nkrCodes, aplica a todo lo que cambió y no tuvo
// error; con nkrCodes, solo a ese subconjunto (ej. lo que el usuario tildó).
export function applyRecalculateCatalogPrices(nkrCodes = null) {
  const payload = nkrCodes ? { nkr_codes: nkrCodes } : {};
  return httpStore
    .post("/part_price_catalog/recalculate", payload)
    .then(res => res.data);
}
